import CalendarIcon from '@/components/icons/CalendarIcon';
import PackageIcon from '@/components/icons/PackageIcon';
import OwnersIcon from '@/components/icons/OwnersIcon';
import ApartmentIcon from '@/components/icons/ApartmentIcon';
import MoneyIcon from '@/components/icons/MoneyIcon';
import Mail_02_Icon from '@/components/icons/Mail_02_Icon';
import Exchange_01_Icon from '@/components/icons/Exchange_01_Icon';
import NotificationIcon from '@/components/icons/NotificationIcon';

export type SuperAdminDataHubItem = {
    key: string;
    titleKey: string;
    path: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
};

export const superAdminDataHubItems: SuperAdminDataHubItem[] = [
    {
        key: 'bookings',
        titleKey: 'superAdmin.data.hub.bookings',
        path: '/superAdmin/data/bookings',
        icon: CalendarIcon,
    },
    {
        key: 'orders',
        titleKey: 'superAdmin.data.hub.orders',
        path: '/superAdmin/data/orders',
        icon: PackageIcon,
    },
    {
        key: 'owners',
        titleKey: 'superAdmin.data.hub.owners',
        path: '/superAdmin/data/owners',
        icon: OwnersIcon,
    },
    {
        key: 'rooms',
        titleKey: 'superAdmin.data.hub.rooms',
        path: '/superAdmin/data/rooms',
        icon: ApartmentIcon,
    },
    {
        key: 'rentCharges',
        titleKey: 'superAdmin.data.hub.rentCharges',
        path: '/superAdmin/data/rent-charges',
        icon: MoneyIcon,
    },
    {
        key: 'inbox',
        titleKey: 'superAdmin.data.hub.inbox',
        path: '/superAdmin/data/inbox',
        icon: Mail_02_Icon,
    },
    {
        key: 'outbox',
        titleKey: 'superAdmin.data.hub.outbox',
        path: '/superAdmin/data/outbox',
        icon: Exchange_01_Icon,
    },
    {
        key: 'internalOutbox',
        titleKey: 'superAdmin.data.hub.internalOutbox',
        path: '/superAdmin/data/internal-outbox',
        icon: NotificationIcon,
    },
    {
        key: 'emailOutbox',
        titleKey: 'superAdmin.data.hub.emailOutbox',
        path: '/superAdmin/data/email-outbox',
        icon: Mail_02_Icon,
    },
];
